export const NEWS_ROUTES = {
  GET_NEWS: "/club/news",
}